import { nlApp, nlWebsite } from './strings';

const nl = {
  translation: {
    ...nlWebsite,
    ...nlApp
  }
};

export default nl;
